export default __webpack_public_path__ + "static/media/mycoupons.b96fc8ab.svg";